import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n';
import SlideUpDown from 'vue3-slide-up-down';

//import VueGoogleMaps from '@fawmi/vue-google-maps';
import FirstFieldset from './components/FirstFieldset';
import SecondFieldset from './components/SecondFieldset';
import ThirdFieldset from './components/ThirdFieldset';

const app = createApp(App);
/*app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC0bp0ut7w4xZvNJlVCOlBJ9VuRNM5jApY',
        language: 'nl',
    },
    autobindAllEvents: true,
  });*/
app.use(i18n);
app.component('slide-up-down', SlideUpDown);
app.component('first-fieldset', FirstFieldset);
app.component('second-fieldset', SecondFieldset);
app.component('third-fieldset', ThirdFieldset);

app.mount('.prijscalculator-app');
